import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Tooltip } from "../Tooltip/Tooltip";
import getTestIDs from "../../../utils/getTestIDs";
import "./ProgressBar.scss";

export const testIDs = getTestIDs();

export class ProgressBar extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    percentages: PropTypes.arrayOf(
      PropTypes.shape({
        percent: PropTypes.number,
        color: PropTypes.string,
        tooltip: PropTypes.string,
      })
    ),
    disabledPercentage: PropTypes.shape({
      percent: PropTypes.number,
      tooltip: PropTypes.string,
    }),
  };

  render() {
    const { className, disabledPercentage, percentages } = this.props;
    const progressClass = classNames("progress", className);

    return (
      <div className={progressClass} data-testid="progress-bar">
        {percentages
          .sort((a, b) => a.percent - b.percent)
          .map((percentage, index) => (
            <Tooltip
              content={percentage.tooltip || percentage.percent}
                key={`progress-${index}`}  // eslint-disable-line
            >
              <div
                className={`progress__fill${index + 1}`}
                data-testid="progress-1"
                style={{
                  width: `${Math.min(100, percentage.percent)}%`,
                  background: `${percentage.color}`,
                }}
              />
            </Tooltip>
          ))}

        {disabledPercentage && (
          <Tooltip
            content={disabledPercentage.tooltip || disabledPercentage.percent}
            data-testid={testIDs.disabledPercentageBar}
          >
            <div
              className="progress__Disabled"
              data-testid="progress-2"
              style={{
                width: `${Math.min(100, disabledPercentage.percent)}%`,
              }}
            />
          </Tooltip>
        )}
      </div>
    );
  }
}

export default ProgressBar;
